import React, { createContext, useContext, useState } from 'react'

interface DelhiveryPreviewContextType {
  showDelhiveryPreview: boolean
  setShowDelhiveryPreview: (v: boolean) => void
}

const DelhiveryPreviewContext = createContext<DelhiveryPreviewContextType | undefined>(undefined)

export const DelhiveryPreviewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showDelhiveryPreview, setShowDelhiveryPreview] = useState(false)

  return (
    <DelhiveryPreviewContext.Provider value={{ showDelhiveryPreview, setShowDelhiveryPreview }}>
      {children}
    </DelhiveryPreviewContext.Provider>
  )
}

export const useDelhiveryPreview = () => {
  const ctx = useContext(DelhiveryPreviewContext)
  if (!ctx) throw new Error('useDelhiveryPreview must be used within DelhiveryPreviewProvider')
  return ctx
}
